import { lazy } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import { PasswordActions } from '@enums/handle-password';
import {
  ForgotPassword,
  HandlePassword,
  Login,
  SelectWorkspace,
} from '@pages/index';

import { AuthenticatedRedirect } from './AuthenticatedRedirect';
import { AppRoutes, RoutesPath } from './constants';
import LayoutWrapper from './LayoutWrapper';
import ProtectedRoute from './ProtectedRoute';

const HomePage = lazy(() => import('@pages/home-page/HomePage'));
const ManageTeam = lazy(() => import('@pages/manage-team/ManageTeam'));
const NoAccessPage = lazy(() => import('@pages/no-access/NoAccessPage'));
const Workspace = lazy(() => import('@pages/workspace/Workspace'));
const Integrations = lazy(() => import('@pages/integrations/Integrations'));

const AllRoutes = () => {
  return (
    <Routes>
      <Route
        path={RoutesPath.LOGIN}
        element={
          <AuthenticatedRedirect
            to={AppRoutes.BRAND_LIBRARY}
            fallback={<Login />}
          />
        }
      />
      <Route path={RoutesPath.FORGOT_PASSWORD} element={<ForgotPassword />} />
      <Route path={RoutesPath.SELECT_WORKSPACE} element={<SelectWorkspace />} />
      <Route
        path={RoutesPath.RESET_PASSWORD}
        element={<HandlePassword type={PasswordActions.RESET} />}
      />
      <Route
        path={RoutesPath.CREATE_PASSWORD}
        element={<HandlePassword type={PasswordActions.CREATE} />}
      />
      <Route element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute />}>
          <Route path={RoutesPath.BRAND_LIBRARY} element={<HomePage />} />
          <Route
            path={AppRoutes.BRAND_LIBRARY}
            element={
              <AuthenticatedRedirect
                to={AppRoutes.BRAND_LIBRARY}
                fallback={<Login />}
              />
            }
          />
          <Route path={RoutesPath.MANAGE_TEAM} element={<ManageTeam />} />
          <Route path={RoutesPath.WORKSPACE} element={<Workspace />} />
          <Route path={RoutesPath.INTEGRATIONS} element={<Integrations />} />
        </Route>
      </Route>
      <Route path={RoutesPath.NO_ACCESS} element={<NoAccessPage />} />
      <Route
        path={RoutesPath.ALL}
        element={<Navigate replace to={RoutesPath.LOGIN} />}
      />
    </Routes>
  );
};

export default AllRoutes;
